import { render, staticRenderFns } from "./BaseChangePasswordForm.vue?vue&type=template&id=2e91b7f0"
import script from "./BaseChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./BaseChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports